var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocalResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 10             L85 30             L85 70             L50 90             L15 70             L15 30 Z",
    fill: "none",
    stroke: "#455A64",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -6 L8 -2 L0 2 L-8 -2 Z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2 L8 -2 L8 6 L0 10 Z",
    fill: "#78909C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2 L-8 -2 L-8 6 L0 10 Z",
    fill: "#607D8B"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -6 L8 -2 L0 2 L-8 -2 Z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2 L8 -2 L8 6 L0 10 Z",
    fill: "#78909C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2 L-8 -2 L-8 6 L0 10 Z",
    fill: "#607D8B"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -6 L8 -2 L0 2 L-8 -2 Z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2 L8 -2 L8 6 L0 10 Z",
    fill: "#78909C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2 L-8 -2 L-8 6 L0 10 Z",
    fill: "#607D8B"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -6 L8 -2 L0 2 L-8 -2 Z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2 L8 -2 L8 6 L0 10 Z",
    fill: "#78909C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2 L-8 -2 L-8 6 L0 10 Z",
    fill: "#607D8B"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -6 L8 -2 L0 2 L-8 -2 Z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2 L8 -2 L8 6 L0 10 Z",
    fill: "#78909C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2 L-8 -2 L-8 6 L0 10 Z",
    fill: "#607D8B"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -6 L8 -2 L0 2 L-8 -2 Z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2 L8 -2 L8 6 L0 10 Z",
    fill: "#78909C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2 L-8 -2 L-8 6 L0 10 Z",
    fill: "#607D8B"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#CFD8DC",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 10,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 30,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 70,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 90,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 70,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 30,
    r: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalResource);
export default __webpack_public_path__ + "static/media/local_resource.3837aad31aab37379b5abd19a35901d9.svg";
export { ForwardRef as ReactComponent };